"use strict";
// Proof of a failed attempt (plan 4.5 screens 5 and 8, rules in plan 4.1): the phone shows the
// checklist and the server checks it again with the same functions.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validCallCount = validCallCount;
exports.attemptMissing = attemptMissing;
/**
 * Calls that count: the first call, then each call at least `minMinutes` after the last one
 * counted. Calls closer together do not count twice.
 */
function validCallCount(calledAt, minMinutes) {
    const times = calledAt.map((t) => new Date(t).getTime()).sort((a, b) => a - b);
    let count = 0;
    let last = -Infinity;
    for (const t of times) {
        if (t - last >= minMinutes * 60_000) {
            count += 1;
            last = t;
        }
    }
    return count;
}
/** What is still missing before a failed attempt can be saved. */
function attemptMissing(input) {
    const { reason, rules } = input;
    if (!reason)
        return ['REASON'];
    const missing = [];
    if (reason.requiresCallProof && validCallCount(input.calledAt, rules.minMinutesBetweenCalls) < rules.callsRequired)
        missing.push('CALLS');
    if (reason.requiresPhoto && rules.gpsPhotoOnFailure && !input.photo?.hasGps)
        missing.push('PHOTO');
    return missing;
}
//# sourceMappingURL=attempt.js.map